<template>
  <main class="l-main p-error">
    <div class="l-block">
      <div v-if="auth.isAuthenticated" class="p-error-nav">
        <Button variant="light" radius @click="logout">
          ログアウト
        </Button>
      </div>
      <div class="l-block__header">
        <router-link :to="{ name: 'login' }">
          <img src="@/assets/img/logo.svg" :alt="$constants.siteName" />
        </router-link>
        <a :href="$constants.leadSiteUrl" data-testid="lead-logo">
          <img src="@/assets/img/logo-lead.svg" alt="SEARCH WRITE LEAD" />
        </a>
      </div>
      <div class="l-block__content p-error__content">
        <h1 class="p-error__title">
          {{ errorMessage }}
        </h1>
        <div class="p-error__buttons">
          <Button
            :to="{ name: 'login' }"
            variant="main"
            size="w260"
            fsize="f16"
            class="l-w-320"
          >
            SEARCH WRITEトップに戻る
          </Button>
          <Button
            :href="$constants.leadSiteUrl"
            variant="main"
            size="w260"
            fsize="f16"
            class="l-w-320"
            data-testid="lead-button"
          >
            SEARCH WRITE LEADトップに戻る
          </Button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Button from '@/components/Button';

export default {
  components: {
    Button
  },
  data() {
    return {
      status: 'error'
    };
  },
  computed: {
    queryError() {
      return this.$route.query.error;
    },
    queryErrorDescription() {
      return this.$route.query.error_description || '';
    },
    queryMessage() {
      return this.$route.query.message || '';
    },
    errorMessage() {
      // Auth0のエラーの種類
      // Change Password Emailの場合
      // https://auth0.com/docs/email/templates#redirect-to-results-for-the-change-password-template
      // Blocked Account Emailの場合
      // https://auth0.com/docs/email/templates#redirect-to-results-for-the-blocked-account-email-template
      if (
        this.queryMessage.includes('Access expired') ||
        this.queryErrorDescription.includes('Access expired')
      ) {
        return 'URLのアクセス有効期限が切れました';
      } else if (
        this.queryMessage.includes('This URL can be used only once') ||
        this.queryErrorDescription.includes('This URL can be used only once')
      ) {
        return 'このURLが使用できるのは1回のみです';
      } else if (
        this.queryMessage.includes('This account is already verified') ||
        this.queryErrorDescription.includes('This account is already verified')
      ) {
        return 'このアカウントは認証済みです';
      } else {
        return 'エラーが発生しました';
      }
    }
  },
  methods: {
    logout() {
      this.auth.logout();
    }
  }
};
</script>
